import { useTranslation } from 'react-i18next';

const benefits = [
  {
    key: 'cinema_creatorBenefit1',
    icon: 'ri-movie-2-line',
    tone: 'text-accent-400 bg-accent-500/15',
  },
  {
    key: 'cinema_creatorBenefit2',
    icon: 'ri-bar-chart-box-line',
    tone: 'text-amber-400 bg-amber-500/15',
  },
  {
    key: 'cinema_creatorBenefit3',
    icon: 'ri-vip-crown-line',
    tone: 'text-emerald-400 bg-emerald-500/15',
  },
];

export default function ApplyView({ onApply, loading, error }: { onApply: () => void; loading?: boolean; error?: string }) {
  const { t } = useTranslation('cinema');

  return (
    <div className="rounded-2xl overflow-hidden border border-background-800/40 animate-ao-fade-in-up">
      <div className="relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Creative%20cinematic%20creator%20studio%20concept%20with%20glowing%20warm%20amber%20and%20golden%20light%20reels%20and%20floating%20story%20frames%20over%20a%20deep%20dark%20elegant%20backdrop%2C%20inspiring%20filmmaking%20atmosphere%2C%20artistic%20bokeh%20and%20premium%20gradients%2C%20motivational%20creative%20energy%2C%20luxurious%20color%20grading%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1200&height=560&seq=creator-apply-bg-1&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/55 to-background-950/30"></div>

        <div className="relative p-6 md:p-8">
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <span className="px-2.5 py-1 rounded-full text-[11px] font-bold text-amber-950 bg-amber-400 whitespace-nowrap">
              {t('cinema_creatorMemberReady')}
            </span>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            {t('cinema_creatorBecome')}
          </h2>
          <p className="text-xs md:text-sm text-foreground-300 mt-2 max-w-xl leading-relaxed">
            {t('cinema_creatorGateDesc')}
          </p>

          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            className="mt-5 px-6 py-3 rounded-full text-sm font-semibold text-background-950 bg-accent-500 hover:bg-accent-400 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            {loading ? <i className="ri-loader-4-line animate-spin text-lg" /> : t('cinema_creatorApplyBtn')}
          </button>
          {error && <p className="mt-3 text-xs text-rose-300">{error}</p>}
        </div>
      </div>

      <div className="bg-background-900/50 p-4 md:p-6">
        <h4 className="text-sm font-bold text-foreground-100 mb-4">{t('cinema_creatorBenefitTitle')}</h4>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {benefits.map((b) => (
            <div
              key={b.key}
              className="rounded-xl bg-background-900/60 border border-background-800/50 p-4 flex items-start gap-3"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${b.tone}`}>
                <i className={`${b.icon} text-lg`}></i>
              </span>
              <p className="text-xs md:text-sm text-foreground-300 leading-relaxed pt-1">{t(b.key)}</p>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-foreground-600 mt-4 flex items-center gap-1.5">
          <i className="ri-shield-check-line text-foreground-500"></i>
          {t('cinema_creatorReviewTip')}
        </p>
      </div>
    </div>
  );
}
